import React, { memo, useState, useEffect } from "react";
import Modal from "./Modal";
import "./styles/scss/BeforeClose.scss";

function App(props) {
	const { isShow, onClose } = props;
	const [radio, setRadio] = useState(0);
	const [checkbox, setCheckbox] = useState(false);

	useEffect(() => {
		if (isShow) return;
		setRadio(0);
		setCheckbox(false);
	}, [isShow]);

	return (
		<Modal
			className="popup-before-close"
			visible={isShow}
			onClose={onClose}
			style={{ paddingLeft: 37 }}
		>
			<div className="popup-content">
				<span>关闭提示</span>
				<div className="content">
					<div>
						<div className="radio">
							{["隐藏到任务栏托盘", "退出主程序"].map((ele, index) => {
								return (
									<div
										key={index}
										onClick={() => {
											setRadio(index);
										}}
									>
										<button
											type="button"
											className={radio === index ? "active" : ""}
										></button>
										{ele}
									</div>
								);
							})}
						</div>
						<div
							className="checkbox"
							onClick={() => {
								setCheckbox((c) => !c);
							}}
						>
							<button
								type="button"
								className={checkbox ? "active" : ""}
							></button>
							不再提示
						</div>
					</div>
				</div>
				<div className="btn-group">
					<button
						type="button"
						onClick={() => {
							onClose();

							if (checkbox) {
								window.mbQuery?.setCloseTips?.(radio);
							}

							setTimeout(() => {
								if (radio === 0) {
									window.mbQuery?.hide?.();
								} else if (radio === 1) {
									window.mbQuery?.close?.();
								}
							});
						}}
					>
						确定
					</button>
				</div>
			</div>
		</Modal>
	);
}

export default memo(App);
